const language = {
    'pt': 
        {
            add_new:            'Adicionar novo',
            add_action:         'Adicionar ação',
            add_aposta:         'Adicionar aposta',
            add_risco:          'Adicionar risco',
            add_followup:       'Adicionar acompanhamento',
            cancel:             'Cancelar', back: 'Voltar',
            component:          'Apostas / Riscos',
            component_new:      'Nova Apostas / Riscos',
            component_edit:     'Editar Apostas / Riscos',
            component_list:     'Lista de Apostas / Riscos',
            close:              'Fechar',
            color:              'Cor',
            color_placeholder:  'Introduza a cor',
            color_primary:      'Cor Primária',
            color_secondary:    'Cor Secundária ',
            delete:             'Eliminar',
            delete_title:       'Eliminar Registo',
            delete_text:        'Tem a certeza que pretende continuar?',
            delete_confirm:     'Sim',
            delete_cancel:      'Não',
            delete_error:       'Problema ao apagar registo!',
            delete_success:     'Registo apagado com sucesso!',
            edit:               'Editar',
            edit_title:         'Editar Registo',
            edit_text:          'Tem a certeza que pretende continuar?',
            edit_confirm:       'Sim',
            edit_cancel:        'Não',
            edit_error:         'Problema ao atualizar registo!',
            edit_success:       'Registo atualizado com sucesso!',
            field_activo:       'Ativo?',
            field_visivel:      'Visível?',
            field_avaiable:     'Disponível?',
            field_choose:       'Escolha uma opção',
            field_category:     'Categoria',
            field_category_placeholder: 'Introduza a categoria',
            field_observation:  'Observação',
            field_observation_placeholder: 'Introduza uma observação',
            field_abreviation:  'Abreviatura',
            field_abreviation_placeholder: 'Introduza a abreviação',
            field_adultos:      'Adultos',
            field_adultos_placeholder: 'Introduza o número de adultos',
            field_criancas:     'Crianças',
            field_criancas_placeholder: 'Introduza o número de crianças',
            field_description:  'Descrição',
            field_description_placeholder: 'Introduza a descrição',
            field_forfait:      'Forfait',
            field_forfait_price:  'Preço do Forfait',
            field_forfait_price_placeholder: 'Introduza o preço do Forfait',
            field_forfait_taxe:  'IVA do Forfait',
            field_forfait_taxe_placeholder: 'Introduza o IVA do Forfait',
            field_equipamento:      'Equipamento',
            field_equipamento_price:  'Preço do Equipamento',
            field_equipamento_price_placeholder: 'Introduza o preço do Equipamento',
            field_equipamento_taxe:  'IVA do Equipamento',
            field_equipamento_taxe_placeholder: 'Introduza o IVA do Equipamento',
            field_final_price:  'Preço Final',
            field_final_price_palceholder: 'Introduza o Preço Final',
            field_price:        'Preço',
            field_price_since:  'Preço desde',
            field_name:                 'Identidicação do Documento',
            field_name_placeholder:     'Introduza a identificação do documento',
            field_document_type:      'Tipo de Documento',
            field_status:       'Estado',
            field_comprimento:  'Comprimento',
            field_comprimento_placeholder: 'Inserir comprimento',
            field_dificuldade:     'Dificuldade',
            field_dificuldade_placeholder: 'Inserir dificuldade',
            field_desnivel:     'Desnível (m)',
            field_desnivel_placeholder: 'Inserir desnível (m)',
            field_type:         'Tipo',
            field_duracao:      'Duração',
            field_person:       'Afetação de técnicos',
            field_appointment:  'Afetação de recursos',
            field_tag:              'Código',
            field_tag_placeholder:  'Inserir o código',
            field_storage_type:     'Formato de Armazenamento',
            field_storage_local:    'Local de Armazenamento',
            field_retention_time:   'Tempo de retenção',
            field_state:            'Estado',
            field_version:          'Versão',
            field_aprovation_date:  'Data de aprovação',
            field_aprovation_name:  'Nome do responsável pela aprovação',
            field_edition_date:     'Data de edição',
            field_edition_name:     'Nome do responsável pela edição',
            field_action_choose:                    'Tipo da ação',
            field_action_name:                      'Ação a desenvolver',
            field_action_name_placeholder:          'Introduza a ação a desenvolver',
            field_action_description:               'Ação a desenvolver',
            field_action_description_placeholder:   'Introduza a ação a desenvolver',
            field_action_indicator:                 'Indicador de monitorização',
            field_action_indicator_placeholder:     'Introduza o indicador de monitorização',
            field_action_goal:                      'Meta',
            field_action_goal_placeholder:          'Introduza a meta da ação',
            field_action_goal_initial:              'Meta inicial',
            field_action_goal_initial_placeholder:  'Introduza a meta inicial',
            field_action_goal_actual:               'Meta atual',
            field_action_goal_actual_placeholder:   'Introduza a meta atual',
            field_action_deadline_initial:              'Deadline inicial',
            field_action_deadline_initial_placeholder:  'Introduza o deadline inicial',
            field_action_deadline_actual:               'Deadline atual',
            field_action_deadline_actual_placeholder:   'Introduza o deadline atual',
            field_responsable:                      'Responsável',
            field_importance:                       'Importancia',
            field_urgency:                          'Urgência',
            field_probabilidade:                    'Probabilidade',
            field_impacto:                          'Impacto',
            field_designation:                      'Designação',
            field_followup:                         'Acompanhamento',
            field_action_completed:                 'Acção concluída',
            field_case_completed:                   'No caso de concluída',
            field_case_not_completed:               'No caso de não concluída',
            field_last_update:                      'Última Atualização',
            field_goal_accomplished:                'Meta Cumprida?',
            field_effective_action:                 'Acção Eficaz?',
            field_action_matter:                    'Acção Interessa?',
            field_next_year:                        'Ano seguinte?',
            field_yes:                              'Sim',
            field_no:                               'Não',
            field_justification:                    'Justificação',
            field_decision_date:                    'Data da decisão',
            field_obs_txt:                          'Observações / Resultados Intermédios / Resultado Final',
            field_corrective_action:                'No caso de ser necessário ação correctiva',
            filter_placeholder: 'Procurar',
            id:                 'ID',
            image:              'Imagem',
            images:             'Imagens',
            image_choose:       'Escolher imagem',
            insert_title:       'Novo Registo',
            insert_text:        'Tem a certeza que pretende continuar?',
            insert_confirm:     'Sim',
            insert_cancel:      'Não',
            insert_error:       'Problema ao inserir registo!',
            insert_success:     'Registo inserido com sucesso!',
            principal:          'Principal',
            remove:             'Remover',
            table_rows_per_page:'Registos por página:',
            table_separator:    'de',
            table_all:          'Todos',
            table_title:        'Título',
            table_parent:       'Parent',
            table_date:         'Data',
            table_color:        'Cores',
            table_state:        'Estado',
            table_actions:      'Acções',
            table_empty:        'sem resultados',
            save:               'Salvar',      
            upload_image_error : 'Apenas são permitidos ficheiros jpg, jpeg e png.\nTamanho máximo: 10MB.\n\n' ,
            youtube_choose:     'Youtube',     
            upload_file_error:  'O ficheiro tem mais de 10MB.',
            editable_documents: 'Documento editável',
            pdf_documents:      'Documentos PDF',
            doc_choose:         'Carregar documento',
            field_edit_responsable:     'Responsável de Edição',
            field_aproval_responsable:  'Responsável de Aprovação',
            field_remove_responsable:   'Responsável de Eliminação',
            field_choose_responsable:   'Escolha um responsável',
            field_document_state:       'Estado do documento',
            field_aproval:              'Aprovar',

            notification_aproval_subject:   'Solicitação de aprovação de documento',
            notification_aproval_text:      'Tem uma solicitação para aprovação de um documento. Entre na plataforma para dar seguimento ao pedido.',


            apostas:                    'Apostas',
            riscos:                     'Riscos',
            number_aposta:              'N.º da aposta',
            number_risco:               'N.º do risco',
            number_action:              'N.º da ação',
            field_classification:       'Classificação',
            date_aprovation:            'Data de aprovação',
            date_identification:        'Data de identificação',
            field_actions:              'Ações',
                        
        },
    'en':
        {
            add_new:            'Add new',
            add_action:         'Adicionar ação',
            add_aposta:         'Adicionar aposta',
            add_risco:          'Adicionar risco',
            add_followup:       'Adicionar acompanhamento',
            calendar:           'Calendar',
            cancel:             'Cancel', back: 'Voltar',
            component:          'Apostas / Riscos',
            component_new:      'Nova Apostas / Riscos',
            component_edit:     'Editar Apostas / Riscos',
            component_list:     'Lista de Apostas / Riscos',
            close:              'Close',
            color:              'Color',
            color_placeholder:  'Insert the color',
            color_primary:      'Primary Color',
            color_secondary:    'Secondary Color',
            delete:             'Delete',
            delete_title:       'Delete Regist',
            delete_text:        'Are you sure you want to continue?',
            delete_confirm:     'Yes',
            delete_cancel:      'No',
            delete_error:       'Problem deleting the element!',
            delete_success:     'Element deleted successfully!',
            edit:               'Edit',
            edit_title:         'Edit Regist',
            edit_text:          'Are you sure you want to continue?',
            edit_confirm:       'Yes',
            edit_cancel:        'No',
            edit_error:         'Problem updating element!',
            edit_success:       'Successful updated element!',
            field_activo:       'Ativo?',
            field_visivel:      'Visível?',
            field_avaiable:     'Disponível?',
            field_choose:       'Escolha uma opção',
            field_category:     'Categoria',
            field_category_placeholder: 'Introduza a categoria',
            field_observation:  'Observação',
            field_observation_placeholder: 'Introduza uma observação',
            field_abreviation:  'Abreviatura',
            field_abreviation_placeholder: 'Introduza a abreviação',
            field_adultos:      'Adultos',
            field_adultos_placeholder: 'Introduza o número de adultos',
            field_criancas:     'Crianças',
            field_criancas_placeholder: 'Introduza o número de crianças',
            field_description:  'Descrição',
            field_description_placeholder: 'Introduza a descrição',
            field_forfait:      'Forfait',
            field_forfait_price:  'Preço do Forfait',
            field_forfait_price_placeholder: 'Introduza o preço do Forfait',
            field_forfait_taxe:  'IVA do Forfait',
            field_forfait_taxe_placeholder: 'Introduza o IVA do Forfait',
            field_equipamento:      'Equipamento',
            field_equipamento_price:  'Preço do Equipamento',
            field_equipamento_price_placeholder: 'Introduza o preço do Equipamento',
            field_equipamento_taxe:  'IVA do Equipamento',
            field_equipamento_taxe_placeholder: 'Introduza o IVA do Equipamento',
            field_final_price:  'Preço Final',
            field_final_price_palceholder: 'Introduza o Preço Final',
            field_price:        'Preço',
            field_price_since:  'Preço desde',
            field_name:                 'Identidicação do Documento',
            field_name_placeholder:     'Introduza a identificação do documento',
            field_name:         'Nome',
            field_name_placeholder: 'Introduza o nome',
            field_document_type:      'Tipo de Documento',
            field_status:       'Estado',
            field_comprimento:  'Comprimento',
            field_comprimento_placeholder: 'Inserir comprimento',
            field_dificuldade:     'Dificuldade',
            field_dificuldade_placeholder: 'Inserir dificuldade',
            field_desnivel:     'Desnível (m)',
            field_desnivel_placeholder: 'Inserir desnível (m)',
            field_type:         'Tipo',
            field_duracao:      'Duração',
            field_person:       'Afetação de tecnicos',
            field_appointment:  'Afetação de recursos',
            field_tag:              'Código',
            field_tag_placeholder:  'Inserir o código',
            field_storage_type:     'Formato de Armazenamento',
            field_storage_local:    'Local de Armazenamento',
            field_retention_time:   'Tempo de retenção',
            field_state:            'Estado',
            field_version:          'Versão',
            field_aprovation_date:  'Data de aprovação',
            field_aprovation_name:  'Nome do responsável pela aprovação',
            field_edition_date:     'Data de edição',
            field_edition_name:     'Nome do responsável pela edição',
            field_action_choose:                    'Tipo da ação',
            field_action_name:                      'Ação a desenvolver',
            field_action_name_placeholder:          'Introduza a ação a desenvolver',
            field_action_description:               'Ação a desenvolver',
            field_action_description_placeholder:   'Introduza a ação a desenvolver',
            field_action_indicator:                 'Indicador de monitorização',
            field_action_indicator_placeholder:     'Introduza o indicador de monitorização',
            field_action_goal:                      'Meta',
            field_action_goal_placeholder:          'Introduza a meta da ação',
            field_action_goal_initial:              'Meta inicial',
            field_action_goal_initial_placeholder:  'Introduza a meta inicial',
            field_action_goal_actual:               'Meta atual',
            field_action_goal_actual_placeholder:   'Introduza a meta atual',
            field_action_deadline_initial:              'Deadline inicial',
            field_action_deadline_initial_placeholder:  'Introduza o deadline inicial',
            field_action_deadline_actual:               'Deadline atual',
            field_action_deadline_actual_placeholder:   'Introduza o deadline atual',
            field_responsable:                      'Responsável',
            field_importance:                       'Importancia',
            field_urgency:                          'Urgência',
            field_probabilidade:                    'Probabilidade',
            field_impacto:                          'Impacto',
            field_designation:                      'Designação',
            field_followup:                         'Acompanhamento',
            field_action_completed:                 'Acção concluída',
            field_case_completed:                   'No caso de concluída',
            field_case_not_completed:               'No caso de não concluída',
            field_last_update:                      'Última Atualização',
            field_goal_accomplished:                'Meta Cumprida?',
            field_effective_action:                 'Acção Eficaz?',
            field_action_matter:                    'Acção Interessa?',
            field_next_year:                        'Ano seguinte?',
            field_yes:                              'Sim',
            field_no:                               'Não',
            field_justification:                    'Justificação',
            field_decision_date:                    'Data da decisão',
            field_obs_txt:                          'Observações / Resultados Intermédios / Resultado Final',
            field_corrective_action:                'No caso de ser necessário ação correctiva',
            filter_placeholder: 'Procurar',
            id:                 'ID',
            image:              'Imagem',
            images:             'Imagens',
            image_choose:       'Escolher imagem',
            insert_title:       'New Regist',
            insert_text:        'Are you sure you want to continue?',
            insert_confirm:     'Yes',
            insert_cancel:      'No',
            insert_error:       'Problem updating element!',
            insert_success:     'Successful updated element!',
            principal:          'Principal',
            remove:             'Remove',
            table_rows_per_page:'Regist by page:',
            table_separator:    'of',
            table_all:          'All',
            table_title:        'Title',
            table_parent:       'Parent',
            table_date:         'Date',
            table_color:        'Cores',
            table_state:        'State',
            table_actions:      'Actions',
            table_empty:        'no results',
            save:               'Save',
            upload_image_error : 'Apenas são permitidos ficheiros jpg, jpeg e png.\nTamanho máximo: 10MB.\n\n' ,
            youtube_choose:     'Youtube',     
            upload_file_error:  'O ficheiro tem mais de 10MB.',
            editable_documents: 'Documento editável',
            pdf_documents:      'Documentos PDF',
            doc_choose:         'Carregar documento',
            field_edit_responsable:     'Responsável de Edição',
            field_aproval_responsable:  'Responsável de Aprovação',
            field_remove_responsable:   'Responsável de Eliminação',
            field_choose_responsable:   'Escolha um responsável',
            field_document_state:       'Estado do documento',
            field_aproval:              'Aprovar',

            notification_aproval_subject:   'Solicitação de aprovação de documento',
            notification_aproval_text:      'Tem uma solicitação para aprovação de um documento. Entre na plataforma para dar seguimento ao pedido.',


    apostas:                    'Apostas',
    riscos:                     'Riscos',
            number_aposta:              'N.º da aposta',
            number_risco:               'N.º do risco',
            number_action:              'N.º da ação',
            field_classification:       'Classificação',
            date_aprovation:            'Data de aprovação',
            date_identification:        'Data de identificação',
            field_actions:              'Ações',

        },
    'es':
    {
  add_new:            'Añadir nuevo',
    add_action:         'Adicionar ação', 
            add_aposta:         'Adicionar aposta',
            add_risco:          'Adicionar risco',
            add_followup:       'Adicionar acompanhamento',
    cancel:             'Cancelar', back: 'Voltar',
            component:          'Apostas / Riscos',
            component_new:      'Nova Apostas / Riscos',
            component_edit:     'Editar Apostas / Riscos',
            component_list:     'Lista de Apostas / Riscos',
    close:              'Cerrar',
    color:              'Color',
    color_placeholder:  'Introduzca el color',
    color_primary:      'Color Primario',
    color_secondary:    'Color Secundario',
    delete:             'Eliminar',
    delete_title:       'Eliminar Registro',
    delete_text:        '¿Está seguro de que desea continuar?',
    delete_confirm:     'Sí',
    delete_cancel:      'No',
    delete_error:       '¡Problema al eliminar registro!',
    delete_success:     'Registro eliminado con éxito!',
    edit:               'Editar',
    edit_title:         'Editar Registro',
    edit_text:          '¿Está seguro de que desea continuar?',
    edit_confirm:       'Sí',
    edit_cancel:        'No',
    edit_error:         '¡Problema al actualizar registro!',
    edit_success:       'Registro actualizado con éxito!',
    field_activo:       '¿Activo?',
    field_visivel:      '¿Visible?',
    field_avaiable:     '¿Disponible?',
    field_choose:       'Elija una opción',
    field_category:     'Categoría',
    field_category_placeholder: 'Introduzca la categoría',
    field_observation:  'Observación',
    field_observation_placeholder: 'Introduzca una observación',
    field_abreviation:  'Abreviatura',
    field_abreviation_placeholder: 'Introduzca la abreviatura',
    field_adultos:      'Adultos',
    field_adultos_placeholder: 'Introduzca el número de adultos',
    field_criancas:     'Niños',
    field_criancas_placeholder: 'Introduzca el número de niños',
    field_description:  'Descripción',
    field_description_placeholder: 'Introduzca la descripción',
    field_forfait:      'Forfait',
    field_forfait_price:  'Precio del Forfait',
    field_forfait_price_placeholder: 'Introduzca el precio del Forfait',
    field_forfait_taxe:  'IVA del Forfait',
    field_forfait_taxe_placeholder: 'Introduzca el IVA del Forfait',
    field_equipamento:      'Equipamiento',
    field_equipamento_price:  'Precio del Equipamiento',
    field_equipamento_price_placeholder: 'Introduzca el precio del Equipamiento',
    field_equipamento_taxe:  'IVA del Equipamiento',
    field_equipamento_taxe_placeholder: 'Introduzca el IVA del Equipamiento',
    field_final_price:  'Precio Final',
    field_final_price_palceholder: 'Introduzca el Precio Final',
    field_price:        'Precio',
    field_price_since:  'Precio desde',
    field_name:         'Identificación del Documento',
    field_name_placeholder: 'Introduzca la identificación del documento',
    field_document_type: 'Tipo de Documento',
    field_status:       'Estado',
    field_comprimento:  'Longitud',
    field_comprimento_placeholder: 'Introduzca la longitud',
    field_dificuldade:  'Dificultad',
    field_dificuldade_placeholder: 'Introduzca la dificultad',
    field_desnivel:     'Desnivel (m)',
    field_desnivel_placeholder: 'Introduzca el desnivel (m)',
    field_type:         'Tipo',
    field_duracao:      'Duración',
    field_person:       'Asignación de técnicos',
    field_appointment:  'Asignación de recursos',
    field_tag:          'Código',
    field_tag_placeholder: 'Introduzca el código',
    field_storage_type: 'Formato de Almacenamiento',
    field_storage_local:'Ubicación de Almacenamiento',
    field_retention_time:'Tiempo de Retención',
    field_state:        'Estado',
    field_version:      'Versión',
    field_aprovation_date: 'Fecha de Aprobación',
    field_aprovation_name: 'Nombre del Responsable de Aprobación',
    field_edition_date: 'Fecha de Edición',
    field_edition_name: 'Nombre del Responsable de Edición',
            field_action_choose:                    'Tipo da ação',
            field_action_name:                      'Ação a desenvolver',
            field_action_name_placeholder:          'Introduza a ação a desenvolver',
            field_action_description:               'Ação a desenvolver',
            field_action_description_placeholder:   'Introduza a ação a desenvolver',
            field_action_indicator:                 'Indicador de monitorização',
            field_action_indicator_placeholder:     'Introduza o indicador de monitorização',
            field_action_goal:                      'Meta',
            field_action_goal_placeholder:          'Introduza a meta da ação',
            field_action_goal_initial:              'Meta inicial',
            field_action_goal_initial_placeholder:  'Introduza a meta inicial',
            field_action_goal_actual:               'Meta atual',
            field_action_goal_actual_placeholder:   'Introduza a meta atual',
            field_action_deadline_initial:              'Deadline inicial',
            field_action_deadline_initial_placeholder:  'Introduza o deadline inicial',
            field_action_deadline_actual:               'Deadline atual',
            field_action_deadline_actual_placeholder:   'Introduza o deadline atual',
            field_responsable:                      'Responsável',
            field_importance:                       'Importancia',
            field_urgency:                          'Urgência',
            field_probabilidade:                    'Probabilidade',
            field_impacto:                          'Impacto',
            field_designation:                      'Designação',
            field_followup:                         'Acompanhamento',
            field_action_completed:                 'Acção concluída',
            field_case_completed:                   'No caso de concluída',
            field_case_not_completed:               'No caso de não concluída',
            field_last_update:                      'Última Atualização',
            field_goal_accomplished:                'Meta Cumprida?',
            field_effective_action:                 'Acção Eficaz?',
            field_action_matter:                    'Acção Interessa?',
            field_next_year:                        'Ano seguinte?',
            field_yes:                              'Sim',
            field_no:                               'Não',
            field_justification:                    'Justificação',
            field_decision_date:                    'Data da decisão',
    filter_placeholder:'Buscar',
    id:                 'ID',
    image:              'Imagen',
    images:             'Imágenes',
    image_choose:       'Elegir imagen',
    insert_title:       'Nuevo Registro',
    insert_text:        '¿Está seguro de que desea continuar?',
    insert_confirm:     'Sí',
    insert_cancel:      'No',
    insert_error:       '¡Problema al insertar registro!',
    insert_success:     'Registro insertado con éxito!',
    principal:          'Principal',
    remove:             'Eliminar',
    table_rows_per_page:'Registros por página:',
    table_separator:    'de',
    table_all:          'Todos',
    table_title:        'Título',
    table_parent:       'Padre',
    table_date:         'Fecha',
    table_color:        'Colores',
    table_state:        'Estado',
    table_actions:      'Acciones',
    table_empty:        'sin resultados',
    save:               'Guardar',
    upload_image_error: 'Solo archivos jpg, jpeg y png.\nTamaño máximo: 10MB.\n\n',
    youtube_choose:     'Youtube',
    upload_file_error:  'El archivo supera los 10MB.',
    editable_documents: 'Documento editable',
    pdf_documents:      'Documentos PDF',
    doc_choose:         'Subir documento',
    field_edit_responsable:     'Responsable de Edición',
    field_aproval_responsable:  'Responsable de Aprobación',
    field_remove_responsable:   'Responsable de Eliminación',
    field_choose_responsable:   'Elija un responsable',
    field_document_state:       'Estado del documento',
    field_aproval:              'Aprobar',
    notification_aproval_subject: 'Solicitud de aprobación de documento',
    notification_aproval_text:    'Tienes una solicitud para aprobación de un documento. Ingresa a la plataforma para continuar.',


    apostas:                    'Apostas',
    riscos:                     'Riscos',
            number_aposta:              'N.º da aposta',
            number_risco:               'N.º do risco',
            number_action:              'N.º da ação',
            field_classification:       'Classificação',
            date_aprovation:            'Data de aprovação',
            date_identification:        'Data de identificação',
            field_actions:              'Ações',
  
    },
    'fr':{
 add_new:            'Ajouter nouveau',
            add_action:         'Adicionar ação',
            add_aposta:         'Adicionar aposta',
            add_risco:          'Adicionar risco',
            add_followup:       'Adicionar acompanhamento',
    cancel:             'Annuler',
            component:          'Apostas / Riscos',
            component_new:      'Nova Apostas / Riscos',
            component_edit:     'Editar Apostas / Riscos',
            component_list:     'Lista de Apostas / Riscos',
    close:              'Fermer',
    color:              'Couleur',
    color_placeholder:  'Insérer la couleur',
    color_primary:      'Couleur Principale',
    color_secondary:    'Couleur Secondaire',
    delete:             'Supprimer',
    delete_title:       'Supprimer l’enregistrement',
    delete_text:        'Êtes-vous sûr de vouloir continuer ?',
    delete_confirm:     'Oui',
    delete_cancel:      'Non',
    delete_error:       'Problème lors de la suppression !',
    delete_success:     'Enregistrement supprimé avec succès !',
    edit:               'Modifier',
    edit_title:         'Modifier l’enregistrement',
    edit_text:          'Êtes-vous sûr de vouloir continuer ?',
    edit_confirm:       'Oui',
    edit_cancel:        'Non',
    edit_error:         'Problème lors de la mise à jour !',
    edit_success:       'Enregistrement mis à jour avec succès !',
    field_activo:       'Actif ?',
    field_visivel:      'Visible ?',
    field_avaiable:     'Disponible ?',
    field_choose:       'Choisir une option',
    field_category:     'Catégorie',
    field_category_placeholder: 'Insérer la catégorie',
    field_observation:  'Observation',
    field_observation_placeholder: 'Insérer une observation',
    field_abreviation:  'Abréviation',
    field_abreviation_placeholder: 'Insérer l’abréviation',
    field_adultos:      'Adultes',
    field_adultos_placeholder: 'Insérer le nombre d’adultes',
    field_criancas:     'Enfants',
    field_criancas_placeholder: 'Insérer le nombre d’enfants',
    field_description:  'Description',
    field_description_placeholder: 'Insérer la description',
    field_forfait:      'Forfait',
    field_forfait_price: 'Prix du Forfait',
    field_forfait_price_placeholder: 'Insérer le prix du Forfait',
    field_forfait_taxe: 'TVA du Forfait',
    field_forfait_taxe_placeholder: 'Insérer la TVA du Forfait',
    field_equipamento:      'Équipement',
    field_equipamento_price: 'Prix de l’Équipement',
    field_equipamento_price_placeholder: 'Insérer le prix de l’Équipement',
    field_equipamento_taxe: 'TVA de l’Équipement',
    field_equipamento_taxe_placeholder: 'Insérer la TVA de l’Équipement',
    field_final_price:    'Prix Final',
    field_final_price_palceholder: 'Insérer le Prix Final',
    field_price:          'Prix',
    field_price_since:    'Prix depuis',
    field_name:           'Identification du Document',
    field_name_placeholder: 'Insérer l’identification du document',
    field_document_type: 'Type de Document',
    field_status:         'État',
    field_comprimento:    'Longueur',
    field_comprimento_placeholder: 'Insérer la longueur',
    field_dificuldade:    'Difficulté',
    field_dificuldade_placeholder: 'Insérer la difficulté',
    field_desnivel:       'Dénivelé (m)',
    field_desnivel_placeholder: 'Insérer le dénivelé (m)',
    field_type:           'Type',
    field_duracao:        'Durée',
    field_person:         'Affectation des techniciens',
    field_appointment:    'Affectation des ressources',
    field_tag:            'Code',
    field_tag_placeholder:'Insérer le code',
    field_storage_type:   'Format de Stockage',
    field_storage_local:  'Emplacement de Stockage',
    field_retention_time: 'Durée de Conservation',
    field_state:          'État',
    field_version:        'Version',
    field_aprovation_date:'Date d’approbation',
    field_aprovation_name:'Nom du responsable approbation',
    field_edition_date:   'Date d’édition',
    field_edition_name:   'Nom du responsable édition',
            field_action_choose:                    'Tipo da ação',
            field_action_name:                      'Ação a desenvolver',
            field_action_name_placeholder:          'Introduza a ação a desenvolver',
            field_action_description:               'Ação a desenvolver',
            field_action_description_placeholder:   'Introduza a ação a desenvolver',
            field_action_indicator:                 'Indicador de monitorização',
            field_action_indicator_placeholder:     'Introduza o indicador de monitorização',
            field_action_goal:                      'Meta',
            field_action_goal_placeholder:          'Introduza a meta da ação',
            field_action_goal_initial:              'Meta inicial',
            field_action_goal_initial_placeholder:  'Introduza a meta inicial',
            field_action_goal_actual:               'Meta atual',
            field_action_goal_actual_placeholder:   'Introduza a meta atual',
            field_action_deadline_initial:              'Deadline inicial',
            field_action_deadline_initial_placeholder:  'Introduza o deadline inicial',
            field_action_deadline_actual:               'Deadline atual',
            field_action_deadline_actual_placeholder:   'Introduza o deadline atual',
            field_responsable:                      'Responsável',
            field_importance:                       'Importancia',
            field_urgency:                          'Urgência',
            field_probabilidade:                    'Probabilidade',
            field_impacto:                          'Impacto',
            field_designation:                      'Designação',
            field_followup:                         'Acompanhamento',
            field_action_completed:                 'Acção concluída',
            field_case_completed:                   'No caso de concluída',
            field_case_not_completed:               'No caso de não concluída',
            field_last_update:                      'Última Atualização',
            field_goal_accomplished:                'Meta Cumprida?',
            field_effective_action:                 'Acção Eficaz?',
            field_action_matter:                    'Acção Interessa?',
            field_next_year:                        'Ano seguinte?',
            field_yes:                              'Sim',
            field_no:                               'Não',
            field_justification:                    'Justificação',
            field_decision_date:                    'Data da decisão',
            field_obs_txt:                          'Observações / Resultados Intermédios / Resultado Final',
            field_corrective_action:                'No caso de ser necessário ação correctiva',
    filter_placeholder:  'Rechercher',
    id:                   'ID',
    image:                'Image',
    images:               'Images',
    image_choose:         'Choisir une image',
    insert_title:         'Nouvel Enregistrement',
    insert_text:          'Êtes-vous sûr de vouloir continuer ?',
    insert_confirm:       'Oui',
    insert_cancel:        'Non',
    insert_error:         'Problème lors de l’insertion !',
    insert_success:       'Enregistrement inséré avec succès !',
    principal:            'Principal',
    remove:               'Supprimer',
    table_rows_per_page:  'Enregistrements par page :',
    table_separator:      'de',
    table_all:            'Tous',
    table_title:          'Titre',
    table_parent:         'Parent',
    table_date:           'Date',
    table_color:          'Couleurs',
    table_state:          'État',
    table_actions:        'Actions',
    table_empty:          'aucun résultat',
    save:                 'Sauvegarder',
    upload_image_error:   'Seuls les fichiers jpg, jpeg et png sont autorisés.\nTaille max : 10 Mo.\n\n',
    youtube_choose:       'Youtube',
    upload_file_error:    'Le fichier dépasse 10 Mo.',
    editable_documents:   'Document modifiable',
    pdf_documents:        'Documents PDF',
    doc_choose:           'Télécharger document',
    field_edit_responsable:    'Responsable d’Édition',
    field_aproval_responsable: 'Responsable d’Approbation',
    field_remove_responsable:  'Responsable de Suppression',
    field_choose_responsable:  'Choisissez un responsable',
    field_document_state:      'État du document',
    field_aproval:             'Approuver',
    notification_aproval_subject: 'Demande d’approbation de document',
    notification_aproval_text:    'Vous avez une demande d’approbation de document. Connectez-vous',


    apostas:                    'Apostas',
    riscos:                     'Riscos',
            number_aposta:              'N.º da aposta',
            number_risco:               'N.º do risco',
            number_action:              'N.º da ação',
            field_classification:       'Classificação',
            date_aprovation:            'Data de aprovação',
            date_identification:        'Data de identificação',
            field_actions:              'Ações',
    },
}

module.exports = {
    language
};